import { queryOptions, useQuery } from '@tanstack/react-query';
import { getPageUsernames } from '@linkie/api-client';
const getPageUsernamesQueryOptions = (userId) => {
    return queryOptions({
        queryKey: ['page-usernames', userId],
        queryFn: () => getPageUsernames(userId),
    });
};
const useGetPageUsernames = (userId, { queryConfig } = {}) => {
    return useQuery(Object.assign(Object.assign({}, getPageUsernamesQueryOptions(userId)), queryConfig));
};
export default useGetPageUsernames;
//# sourceMappingURL=useGetPageUsernames.hook.js.map